import {BetLineEvent} from "@nolimitcity/slot-game/bin/core/betline/event/BetLineEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IScreenConfig, ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {TimelineLite} from "gsap";
import {EdisonGameModuleConfig} from "../../EdisonGameModuleConfig";
import {EdisonGameMode} from "../../gameMode/EdisonGameMode";
import {EdisonParsedGameData} from "../../server/data/EdisonParsedGameData";
import {EdisonParsedInitData} from "../../server/data/EdisonParsedInitData";


/**
 * Created by Alican Köker on 2019-04-11.
 */

export class EdisonRespinIntroController extends ScreenController {

    private _isRestore:boolean = false;
    private _initData:EdisonParsedInitData;
    private _gameData:ParsedServerData;
    private _showed:boolean = false;

    constructor(config:IScreenConfig, tweakEnabled?:boolean) {
        super("EdisonRespinIntroController", config, tweakEnabled);

        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    protected parseFeatureGameData(data:ParsedServerData):void {
        this._gameData = data;
        this._showed = false;
    }

    protected doTransitions():void {

    }

    protected onInitDataParsed(data:EdisonParsedInitData):void {
        this._isRestore = data.isRestoreState;
        this._initData = data;
    }

    protected calculateIsTriggered(data:ParsedServerData):boolean {
        const isRestoreState:boolean = (data instanceof ParsedInitData) ? (<ParsedInitData>data).isRestoreState : false;

        if(data instanceof EdisonParsedInitData) {
            this._initData = data;
        } else if(data instanceof EdisonParsedGameData)
            this._gameData = data;

        //this._isRestore = (<EdisonParsedInitData>data)!.isRestoreState;
        this._isRestore = isRestoreState;
        return data.mode === EdisonGameMode.NORMAL && data.nextMode === EdisonGameMode.STACKED_RESPIN;
    }

    public close(closeCallback?:() => void):void {
        super.close();
    }

    protected show():boolean {
        if(this._isRestore && !this._showed) {
            EdisonGameModuleConfig.background.currentMode = EdisonGameMode.STACKED_RESPIN;
            (<EdisonParsedInitData>this._gameData)!.stackedModeOverlay.forEach((value, index, array) => {
                if(value) {
                    let sym:string = this._gameData!.reels[index][2];
                    if(sym)
                        EdisonGameModuleConfig.respinOverlay.restoreOverlay(sym, index);
                }
            });
            EventHandler.dispatchEvent(new GameEvent(SpinEvent.WANT_SKIPPABLE));
            this._isRestore = false;
        }

        if(this.shouldShow()) {
            if(!this._showed)
                this._view.show(this._serverData!, () => this.onShowComplete());
            SlotGame.keypad.hide();
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.SET_ENABLED, false));
            EventHandler.dispatchEvent(new GameEvent(BetLineEvent.HIDE_ALL_BET_LINES));
            EventHandler.dispatchEvent(new GameEvent(StageEvent.WANT_RESIZE));
        }

        // When restore in freespin, don't show the intro but we need the intro to init the freespin scene.
        if(this.doTransitions) {
            this.doTransitions();
        }

        this._showed = true;
        return true;
    }

    protected onShowComplete():void {
        let tl:TimelineLite = new TimelineLite();
        tl.add(() => this.close(), 2);
        tl.add(() => {
            EdisonGameModuleConfig.respinOverlay.playWildOverlays()
        }, 4);
    }

    protected shouldShow():boolean {
        return true;
    }
}